<template>
    <div class='spaceCenter common common-form-inline'>
        <a-form-model
        style="width:400px"
        ref="ruleForm"
        :model="pageData"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        >
            <a-form-model-item label="用户名" prop="loginName">
                <a-input v-model="pageData.loginName" :disabled="!noInit"/>
            </a-form-model-item>
            <a-form-model-item label="手机号码/电子邮箱" prop="mobileOrEmail">
                <a-input v-model="pageData.mobileOrEmail"/>
            </a-form-model-item>
            <a-form-model-item label="验证码" prop="captchaCode">
                <div class="input-box">
                    <a-input v-model="pageData.captchaCode"/>
                    <a-button @click="onFetchCode()" type="primary" :disabled="codeAble||countDisabled" size="small" class="input-btn">
                        <span v-show="counter>0">{{counter}}</span>{{countDisabled?"s重新获取":"免费获取验证码"}}
                    </a-button>
                </div>
                <div class="text-size-12 text-color-red" style="position:absolute;white-space: nowrap;">{{errMsg}}</div>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import {getUserInfo,getApproveInfoByAprvId,checkUser,getCaptcha,checkMobile} from "@/api/security.js"
export default {
    props:["noInit"],
    name:"user-modify",
    data() {
        return {
            labelCol: { span: 9 },
            wrapperCol: { span: 15 },
            pageData:{
                loginName:""
            },
            rules:{
                loginName:{
                    required: true,
                    message: "请填写用户名",
                    trigger: "blur",
                    whitespace:true
                },
                mobileOrEmail:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            console.log(!value)
                            cbfn('请填写手机号码/电子邮箱');
                        }
                        const isEmail = this.pageData.mobileOrEmail.match(this.utils.regExpObj.EMAIL_PATTERN);
                        const isMobile = this.pageData.mobileOrEmail.match(this.utils.regExpObj.MOBILE_PATTERN);
                        if(!isEmail && !isMobile){
                            cbfn('手机号码/电子邮箱格式不正确');
                        }

                        if (isEmail) {
                            this.captchaType = 'EMAIL';
                            this.checkVal(cbfn);
                        }
                        else if (isMobile) {
                            this.captchaType = 'SMS';
                            this.checkVal(cbfn);
                        }

                    }
                },
                captchaCode:{
                    required: true,
                    message: "请填写验证码",
                    trigger: "blur",
                    whitespace:true
                }
            },
            codeAble:true,
            captchaType:'SMS',
            counter:0,
            countDisabled:false,
            errMsg:""
        };
    },
    computed: {},
    methods: {
        getUserInfo(){
            getUserInfo(null,true).then(res => {
                this.$store.commit("home/setUserObjSecurity",res.data);
                this.pageData.loginName = res.data.loginName;
            }).catch(err => {
                this.$store.commit("home/setUserObjSecurity",{});
            })
        },
        checkVal(cbfn){
            const self = this;
            const param = {
                loginName: this.pageData.loginName,
                mobileOrEmail: this.pageData.mobileOrEmail,
                captchaType: this.captchaType
            }
            const success = function(res){
                self.$store.commit("home/setLoadMainStatus",false);
                if(res.status == 200){
                    self.codeAble = false;
                    cbfn();
                }else{
                    cbfn(res.description);
                }
            };
            const fail = function(err){
                cbfn(err.description);
                self.$store.commit("home/setLoadMainStatus",false);
            };
            checkUser(param,true,success,fail)
        },
        countTimmer(init){
            if(init) {
                this.countDisabled = true;
                this.counter = 60;
            }
            if(this.counter > 0){
                setTimeout(() => {
                    this.counter --;
                    this.countTimmer();
                },1000)
            }else{
                this.countDisabled = false;
            }
        },
        // 发送验证码
        onFetchCode() {
            const params = {
                target: this.pageData.mobileOrEmail
            };
            if (this.captchaType === 'SMS') {
                Object.assign(params, {
                    mode: 'SMS',
                    type: 'pwd'
                });
            }
            else if (this.captchaType === 'EMAIL') {
                Object.assign(params, {
                    mode: 'EMAIL',
                    type: 'pwd'
                });
            }
            getCaptcha(params).then(res => {
                this.countTimmer(true);
                this.$message.success("验证码发送成功");
            }).catch(err => {
                console.log(err);
            });
        },
        check(){
            return new Promise((resolve,reject) => {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            mobileOrEmail: this.pageData.mobileOrEmail,
                            code: this.pageData.captchaCode,
                            jfCode: 'pwd'
                        };
                        checkMobile(params,true).then(res => {
                            this.$store.commit("app/setModfyMobileOrEmail",this.pageData.mobileOrEmail);
                            let userHeader = this.$store.getters["home/getUserHeader"];
                            this.$store.commit("home/setUserHeader",{
                              ...userHeader,
                              loginName:this.pageData.loginName
                            });

                            resolve(res);
                        }).catch(err => {
                            this.$store.commit("app/setModfyMobileOrEmail","");
                            this.errMsg = err.description;
                            reject(err);
                        })

                    } else {
                        return false;
                    }
                });
            })
        }
    },
    created() {
        if(!this.noInit){
            this.getUserInfo();
        }
    }
}
</script>
<style scoped>
    .common-form-inline{
        margin: 40px 0;
    }
    .input-box{
        position: relative;
    }
    .input-btn{
        position: absolute;
        right: 5px;
        top: 8px;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/steps/user-modify.vue